import React, { useEffect, useRef, useState } from "react";
import Icon from "../../../../general/icon";
import { general } from "../../../../../../store/action";
import { connect } from "react-redux";
import DatePickerField from "../../../../general/form/datePickerField";
import Tooltip from "../../../../general/tooltip";
import { Collapse } from "react-bootstrap";
import { TIhioDataAndPrescriptionParaclinicalItemFields } from "../../../../../../types/prescription";
import DebounceField from "../../../../general/form/debounceField";
import {
  ISSUER_TYPE,
  PARACLINICAL_PRESCRIPTION_SERVICE_TYPE,
  PhysiotherapyIllnessConstant,
  PhysiotherapyTreatmentPlanDetails,
  VISIT_MODE,
} from "../../../../../../constants/constant/enum";
import SelectField, {
  AsyncSelectField,
} from "../../../../general/form/selectField";
import TextAreaField from "../../../../general/form/textAreaField";
import { useLocation } from "react-router-dom";
import { useMySearchParams } from "../../../../../../hook/useMySearchParams";
import { asyncSelectLoadOptions } from "../../../../../../utils/asyncSelectLoadOptions";
import {
  useGetTaminComplaintList,
  useGetTaminDiagnosisList,
} from "../../../../../../hook/request/visit/tamin";
import SwitchField from "../../../../general/form/switchField";
import { isToday } from "../../../../../../utils/date";

/*
    کامپوننت مربوط به انتخاب اطلاعات تجویز هر خدمت پاراکلینیک برای نسخه
    Parent: <PrescriptionParaclinicalItem/>
    Children: -
    در این کامپوننت هر یک از خدمت های پاراکلینیک تجویز شده رندر میشود،
    سپس اطلاعات نسخه مانند تعداد خدمت ثبت میشود و اطلاعات آن برای کامپوننت پرنت فرستاده میشود.
*/

type ParaclinicalPrescriptionRowItemProps = {
  item: any;
  index: number;
  insurance?: number;
  control: any;
  errors: any;
  handleShowModal: any;
  onFieldsChange: any;
  addParaclinicalItemToFavorites: any;
  handleParaclinicalModalSubmit: any;
  deleteParaclinicalItemFromList: any;
  register: any;
  watch: any;
  update?: any;
  IhioCheck?: any;
  willDoItMyselfCounter: React.MutableRefObject<number>;
  isVisitForToday: boolean;
};

type TFilterValues = {
  pageNumber?: string;
  perPage?: string;
  search?: string;
};

const ParaclinicalPrescriptionRowItem = ({
  item,
  index,
  insurance,
  control,
  errors,
  onFieldsChange,
  addParaclinicalItemToFavorites,
  handleShowModal,
  handleParaclinicalModalSubmit,
  deleteParaclinicalItemFromList,
  register,
  watch,
  update,
  IhioCheck,
  willDoItMyselfCounter,
  isVisitForToday,
}: ParaclinicalPrescriptionRowItemProps) => {
  const location = useLocation();
  const mode = location?.state?.mode || VISIT_MODE.SHOW.value;
  const { getQueryParams } = useMySearchParams();

  const [showDescription, setShowDescription] = useState(false);
  const [fieldValue, setFieldValue] =
    useState<TIhioDataAndPrescriptionParaclinicalItemFields>();
  const [lastInputTime, setLastInputTime] = useState<number | null>(null);
  const [icd10FilterValues, setIcd10FilterValues] = useState<TFilterValues>({
    pageNumber: "0",
    perPage: "10",
    search: "",
  });
  const [icd10List, setIcd10List] = useState([]);
  const [taminComplaintFilterValues, setTaminComplaintFilterValues] =
    useState<TFilterValues>({
      pageNumber: "0",
      perPage: "10",
      search: "",
    });
  const [taminComplaintList, setComplaintList] = useState([]);
  const [willDoItMyself, setWillDoItMyself] = useState<boolean>(false);

  const diagnosisCallbackRef = useRef<any>(null);
  const complaintCallbackRef = useRef<any>(null);

  // services
  const getTaminIcd10ListRequest = useGetTaminDiagnosisList(
    getQueryParams(icd10FilterValues),
    insurance === ISSUER_TYPE.TAMIN.value && item?.service?.type?.id === 5,
  );
  const getTaminComplaintListRequest = useGetTaminComplaintList(
    getQueryParams(taminComplaintFilterValues),
    insurance === ISSUER_TYPE.TAMIN.value && item?.service?.type?.id === 5,
  );

  useEffect(() => {
    setFieldValue(item);
  }, [item]);

  useEffect(() => {
    if (lastInputTime === null) return;
    const timeout = setTimeout(() => {
      const now = Date.now();
      if (now - lastInputTime >= 5000) {
        IhioCheck(index);
      }
    }, 5000);

    // Cleanup timeout on input change or component unmount
    return () => clearTimeout(timeout);
  }, [lastInputTime]);

  useEffect(() => {
    if (getTaminIcd10ListRequest?.data?.data?.result) {
      const { data } = getTaminIcd10ListRequest.data.data.result,
        _data = data.map((item: any) => ({
          label: item?.name,
          value: item?.id,
        }));
      setIcd10List(_data);
    }
  }, [getTaminIcd10ListRequest?.data?.data?.result]);

  useEffect(() => {
    if (getTaminComplaintListRequest?.data?.data?.result) {
      const { data } = getTaminComplaintListRequest.data.data.result,
        _data = data.map((item: any) => ({
          label: item?.name,
          value: item?.id,
        }));
      setComplaintList(_data);
    }
  }, [getTaminComplaintListRequest?.data?.data?.result]);

  const changeTaminDiagnosisFilterRequest = (
    inputValue: any,
    callback: any,
  ) => {
    diagnosisCallbackRef.current = callback;
    setIcd10FilterValues({
      ...icd10FilterValues,
      search: inputValue,
    });
  };

  useEffect(() => {
    if (diagnosisCallbackRef.current) {
      diagnosisLoadOptions(
        icd10FilterValues.search,
        diagnosisCallbackRef.current,
      );
    }
  }, [icd10FilterValues?.search]);

  const diagnosisLoadOptions = (inputValue: any, callback: any) => {
    asyncSelectLoadOptions(
      inputValue,
      callback,
      icd10FilterValues,
      setIcd10FilterValues,
      getTaminIcd10ListRequest,
    );
  };

  const changeTaminComplaintFilterRequest = (
    inputValue: any,
    callback: any,
  ) => {
    complaintCallbackRef.current = callback;
    setTaminComplaintFilterValues({
      ...taminComplaintFilterValues,
      search: inputValue,
    });
  };

  useEffect(() => {
    if (complaintCallbackRef.current) {
      complaintLoadOptions(
        taminComplaintFilterValues.search,
        complaintCallbackRef.current,
      );
    }
  }, [taminComplaintFilterValues?.search]);

  const complaintLoadOptions = (inputValue: any, callback: any) => {
    asyncSelectLoadOptions(
      inputValue,
      callback,
      taminComplaintFilterValues,
      setTaminComplaintFilterValues,
      getTaminComplaintListRequest,
    );
  };

  /*
    تغییر اطلاعات استیت در کامپوننت پرنت بر اساس اطلاعات تغییر یافته در اینپوت ها.
    @param: e
  */
  // const handleFieldChange = (e: any)=> {
  //   const { name, value } = e?.target;
  //   console.log(name, value)
  //   onFieldsChange(name, value, index, item);
  // };

  const handleFieldChange = (e?: any) => {
    const { name, value } = e?.target;
    const fieldName = name.split("_")[0];
    let fieldValue = { ...item, [fieldName]: value };
    // onFieldsChange(name, value, label, index, item);

    if (insurance === ISSUER_TYPE.IHIO.value) {
      setLastInputTime(Date.now());
    }
    update(index, { ...fieldValue });
  };

  return (
    <div className="bg-primary bg-opacity-10 rounded my-4 px-4 pb-3">
      <div className="d-flex">
        <div className="w-100">
          <div className="d-flex fw-bold font-14 mt-4">
            {(mode === VISIT_MODE.EDIT.value ||
              (insurance === ISSUER_TYPE.ESATA.value &&
                isToday(fieldValue?.activeDate))) && (
              <>
                <div className="p-1 btn btn-gray rounded rounded-3">
                  <span
                    onClick={() => deleteParaclinicalItemFromList(index)}
                    className="mx-2 font-20 d-flex  align-items-center h-100"
                  >
                    <Icon name="trash" />
                  </span>
                </div>
                <div className="p-1 btn btn-gray rounded rounded-3 mx-2">
                  <span
                    onClick={() => addParaclinicalItemToFavorites(index)}
                    className="mx-2 font-20 d-flex  align-items-center h-100"
                  >
                    <Icon name={fieldValue?.paraId ? "star-fill" : "star"} />
                  </span>
                </div>
              </>
            )}
            <div
              onClick={() => setShowDescription(!showDescription)}
              className="d-flex align-items-center align-items-stretch justify-content-center justify-content-md-start mb-3 m-md-0"
            >
              <span className="btn btn-gray rounded d-flex align-items-center px-4 mx-2">
                <span className="d-inline-flex font-25 ms-2 ps-2">
                  <Icon name={`${showDescription ? "chat-close" : "chat"}`} />
                </span>
                توضیحات خدمت
              </span>
            </div>
            {item?.service?.type?.id ===
              PARACLINICAL_PRESCRIPTION_SERVICE_TYPE.PHYSIOTHERAPY.value &&
            insurance === ISSUER_TYPE.TAMIN.value ? ( // اینپوت های مخصوص فیزیوتراپی تامین
              <div className="d-flex me-auto">
                <div className=" me-auto">
                  <div className="form-group mb-2">
                    <SelectField
                      options={PhysiotherapyIllnessConstant}
                      name={`illness_${index}`}
                      placeholder="بیماری"
                      control={control}
                      error={errors}
                      onChange={handleFieldChange}
                      isDisabled={mode === VISIT_MODE.SHOW.value}
                      width={"250px"}
                    />
                  </div>
                </div>
                <div className="me-2">
                  <div className="form-group mb-2">
                    <SelectField
                      options={PhysiotherapyTreatmentPlanDetails}
                      name={`plan_${index}`}
                      placeholder="طرح درمان"
                      control={control}
                      error={errors}
                      onChange={handleFieldChange}
                      isDisabled={mode === VISIT_MODE.SHOW.value}
                      isMulti
                      width={"250px"}
                    />
                  </div>
                </div>
                <div className="w-70 me-2">
                  <div className="form-group mb-2">
                    <DebounceField
                      onChange={handleFieldChange}
                      name={`itemCount_${index}`}
                      className={`text-center`}
                      placeholder="تعداد"
                      control={control}
                      error={errors}
                      disabled={
                        mode === VISIT_MODE.SHOW.value &&
                        insurance !== ISSUER_TYPE.ESATA.value &&
                        !isVisitForToday
                      }
                      // register={register(`root.${index}.itemCount`)}
                      watch={watch(`root.${index}.itemCount`)}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex me-auto">
                <div className="col-3 me-auto">
                  <div className="form-group mb-2">
                    <DebounceField
                      onChange={handleFieldChange}
                      name={`itemCount_${index}`}
                      placeholder="تعداد"
                      control={control}
                      error={errors}
                      disabled={
                        mode === VISIT_MODE.SHOW.value &&
                        insurance !== ISSUER_TYPE.ESATA.value &&
                        !isVisitForToday
                      }
                      // register={register(`root.${index}.itemCount`)}
                      watch={watch(`root.${index}.itemCount`)}
                    />
                  </div>
                </div>
                <div className="col-3 me-2">
                  <div className="form-group mb-2">
                    <DatePickerField
                      name={`activeDate_${index}`}
                      placeholder="ثبت تاریخ"
                      control={control}
                      error={errors}
                      onChange={handleFieldChange}
                      disabled={
                        mode === VISIT_MODE.SHOW.value &&
                        insurance !== ISSUER_TYPE.ESATA.value &&
                        !isVisitForToday
                      }
                      // register={register(`root.${index}.activeDate`)}
                      watch={watch(`root.${index}.activeDate`)}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <div className="col-12 col-md-6 ps-2 me-4">
                    <div className="">
                      <div className="d-flex align-items-center mb-3 pl-5">
                        <span className={"text-nowrap ms-3"}>
                          خودم انجام می‌دهم{" "}
                        </span>
                        <span className="font-20 me-auto">
                          <SwitchField
                            label={""}
                            onChange={(event) => {
                              setWillDoItMyself(event.target.checked);
                              if (event.target.checked) {
                                willDoItMyselfCounter.current =
                                  willDoItMyselfCounter.current + 1;
                              } else {
                                willDoItMyselfCounter.current =
                                  willDoItMyselfCounter.current - 1;
                              }
                            }}
                            name={`willDoItMyself`}
                            value={willDoItMyself}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {item?.service?.type?.id === 5 &&
        insurance === ISSUER_TYPE.TAMIN.value && ( // اینپوت های مخصوص ارجاع تامین
          <div className={"d-flex px-2"}>
            <div className="col-6">
              <div className="form-group mb-2">
                <AsyncSelectField
                  options={icd10List}
                  name={`icd10s_${index}`}
                  placeholder="تشخیص اولیه"
                  control={control}
                  error={errors}
                  onChange={handleFieldChange}
                  asyncLoadOptions={changeTaminDiagnosisFilterRequest}
                  isDisabled={
                    mode === VISIT_MODE.SHOW.value &&
                    insurance !== ISSUER_TYPE.ESATA.value &&
                    !isVisitForToday
                  }
                  isMulti
                />
              </div>
            </div>
            <div className="col-6 me-2">
              <div className="form-group mb-2">
                <AsyncSelectField
                  options={taminComplaintList}
                  name={`complaints_${index}`}
                  placeholder="شکایت"
                  control={control}
                  error={errors}
                  onChange={handleFieldChange}
                  asyncLoadOptions={changeTaminComplaintFilterRequest}
                  isDisabled={
                    mode === VISIT_MODE.SHOW.value &&
                    insurance !== ISSUER_TYPE.ESATA.value &&
                    !isVisitForToday
                  }
                  isMulti
                />
              </div>
            </div>
          </div>
        )}
      <div
        className={`border border-dark-subtle rounded mb-2 ${
          mode === VISIT_MODE.SHOW.value ? "" : "cur-pointer"
        }`}
        onClick={() =>
          mode === VISIT_MODE.EDIT.value &&
          handleShowModal("addPrescriptionParaclinicalItemModal", {
            index: index,
            item: item,
            handleParaclinicalModalSubmit: handleParaclinicalModalSubmit,
            insurance: insurance,
          })
        }
      >
        <div className="d-flex">
          <div className="d-flex col-9 pe-3 my-3">
            <div className="col-6 pe-3">
              <span className="font-9 fw-semibold">{item?.service.name}</span>
            </div>
            <div className="col-6 text-start pe-3">
              <span className="font-en font-9">
                {
                  item?.service.enName &&
                  item?.service.enName !== "nan" &&
                  item?.service.enName !== item?.service?.name
                    ? item?.service?.enName
                    : ""
                  // : item?.service.name
                }
                {/* item?.service.name} */}
              </span>
            </div>
          </div>
          <div className="col-3 ps-2 my-3">
            <div className="d-flex justify-content-end align-items-center pl-5">
              <div className="ltr">
                <span className="fw-bold text-primary font-en ms-1 ">
                  {" "}
                  {index + 1 + ". "}{" "}
                </span>
                <span
                  className={`rounded rounded-3 bg-primary text-white border border-2 border-primary font-12 text-primary text-nowrap px-2 py-1`}
                >
                  {item?.service?.type?.name}
                </span>
              </div>
              {fieldValue?.message?.info?.map((item: string) => {
                return (
                  <Tooltip alt={item} className="p-1 ">
                    <span className="d-flex align-content-center text-primary font-20 me-2">
                      <Icon name={"info-circle"} />
                    </span>
                  </Tooltip>
                );
              })}
              {fieldValue?.message?.warning?.map((item: string) => {
                return (
                  <Tooltip alt={item} className="p-1">
                    <span className="d-flex align-content-center text-yellow font-20 ">
                      <Icon name={"info-circle"} />
                    </span>
                  </Tooltip>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Collapse in={showDescription}>
        <div className={`col-12`}>
          <div className="form-group">
            <TextAreaField
              onChange={handleFieldChange}
              rows={1}
              name={`note_${index}`}
              placeholder="توضیحات خدمت"
              control={control}
              error={errors}
              disabled={mode === VISIT_MODE.SHOW.value}
              // register={register(`root.${index}.note`)}
              watch={watch(`root.${index}.note`)}
            />
          </div>
        </div>
      </Collapse>
      {fieldValue?.message?.error?.map((item: string) => {
        return (
          <div className="bg-light-red mb-1">
            <Icon name={"info"} />
            <span>{item}</span>
          </div>
        );
      })}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) =>
    dispatch(general.handleShowModal(data, body)),
});

export default connect(
  null,
  mapDispatchToProps,
)(ParaclinicalPrescriptionRowItem);
